import React, { useEffect, useState, useRef } from 'react';
import { Plus, ArrowLeft, Search, Heart, Eye, Send, Filter, ChevronDown, Clock, Award, BookOpen, BarChart2, CheckCircle, AlertTriangle, Play, ArrowRight } from 'lucide-react';
import { NewQuestionForm } from '../components/NewQuestionForm';
import { QuestionDetail } from '../components/QuestionDetail';
import { ShareQuestionModal } from '../components/ShareQuestionModal';
import { QuestionSolveInterface } from '../components/QuestionSolveInterface';
import { TestResultsScreen } from '../components/TestResultsScreen';
import { subjectColors, getSubjectGradient, DERS_RENKLERI } from '../utils/constants';
interface Question {
  id: number;
  title: string;
  content: string;
  subject: string;
  topic: string;
  author: string;
  authorType: 'student' | 'teacher';
  createdAt: string;
  options: string[];
  correctOption: number;
  image?: string;
  likes: string[];
  views: number;
  visibility: 'everyone' | 'institution' | 'private';
  targetUsers?: string[];
  archived: boolean;
  responses: {
    id: number;
    author: string;
    authorType: 'student' | 'teacher';
    content: string;
    image?: string;
    createdAt: string;
    verified?: boolean;
    pinned?: boolean;
  }[];
}
// Fen Bilimleri alt konuları için yapı
interface SubTopic {
  title: string;
  topics: string[];
}
// Test interface
interface Test {
  id: number;
  title: string;
  questionCount: number;
  difficulty: 'Kolay' | 'Orta' | 'Zor';
  timeLimit: number; // in minutes
  description?: string;
  questions: any[]; // This would be the actual questions
}
const subjects = [{
  id: 'turkce',
  title: 'Türkçe',
  topics: ['Sözcükte Anlam', 'Deyimler ve Atasözleri', 'Cümlede Anlam', 'Sözel Mantık / Görsel Okuma', 'Parçada Anlam', 'Söz Sanatları', 'Metin Türleri', 'Noktalama İşaretleri', 'Yazım Kuralları', 'Fiilimsiler', 'Cümlenin Öğeleri', 'Cümle Türleri', 'Anlatım Bozukluğu'],
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/53920870-2e72-4897-9a68-0d2901d601e4/image_fx__(5).jpg'
}, {
  id: 'matematik',
  title: 'Matematik',
  topics: ['Çarpanlar ve Katlar', 'Üslü Sayılar', 'Köklü Sayılar', 'Veri Analizi', 'Olasılık', 'Cebirsel İfadeler', 'Doğrusal Denklemler ve Eğim', 'Eşitsizlikler', 'Üçgenler', 'Eşlik ve Benzerlik', 'Dönüşüm Geometrisi', 'Geometrik Cisimler'],
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/472f13e1-d5a1-4908-a2f4-ca37914378a1/image_fx__(6).jpg'
}, {
  id: 'fen',
  title: 'Fen Bilimleri',
  topics: [],
  subTopics: [{
    title: 'Mevsimler ve İklim',
    topics: ['Mevsimlerin Oluşumu', 'İklim ve Hava Hareketleri']
  }, {
    title: 'DNA ve Genetik Kod',
    topics: ['DNA ve Genetik Kod', 'Kalıtım', 'Mutasyon ve Modifikasyon', 'Adaptasyon', 'Biyoteknoloji']
  }, {
    title: 'Basınç',
    topics: ['Basınç']
  }, {
    title: 'Madde ve Endüstri',
    topics: ['Periyodik Sistem', 'Fiziksel ve Kimyasal Değişimler', 'Kimyasal Tepkimeler', 'Asitler ve Bazlar', 'Maddenin Isı ile Etkileşimi', "Türkiye'de Kimya Endüstrisi"]
  }, {
    title: 'Basit Makineler',
    topics: ['Basit Makineler']
  }, {
    title: 'Enerji Dönüşümleri ve Çevre Bilimi',
    topics: ['Besin Zinciri ve Enerji Akışı', 'Enerji Dönüşümleri', 'Madde Döngüleri ve Çevre Sorunları', 'Sürdürülebilir Kalkınma']
  }, {
    title: 'Elektrik Yükleri ve Elektrik Enerjisi',
    topics: ['Elektrik Yükleri ve Elektriklenme', 'Elektrik Yüklü Cisimler', 'Elektrik Enerjisinin Dönüşümü']
  }],
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/342defcc-7c1d-494c-b44e-30031e1df94e/image_fx__(7).jpg'
}, {
  id: 'inkılap',
  title: 'T.C. İnkılap Tarihi ve Atatürkçülük',
  topics: ['Bir Kahraman Doğuyor', 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar', 'Milli Bir Destan: Ya İstiklal, Ya Ölüm', 'Atatürkçülük ve Çağdaşlaşan Türkiye', 'Demokratikleşme Çabaları', 'Atatürk Dönemi Dış Politika', "Atatürk'ün Ölümü ve Sonrası"],
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/8f55533b-a8d1-414d-95ae-dd4d9212be55/image_fx__(8).jpg'
}, {
  id: 'ingilizce',
  title: 'İngilizce',
  topics: ['Friendship', 'Teen Life', 'In The Kitchen', 'On The Phone', 'The Internet', 'Adventures', 'Tourism', 'Chores', 'Science', 'Natural Forces'],
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/ea67535a-604d-4bf1-9bcd-1b4b904b3521/image_fx__(9).jpg'
}, {
  id: 'din',
  title: 'Din Kültürü ve Ahlâk Bilgisi',
  topics: ['Kader İnancı', 'Bir Peygamber Tanıyorum: Hz. Musa', 'Zekat ve Sadaka', 'Din ve Hayat', "Hz. Muhammed'in Örnekliği", "Kur'an-ı Kerim ve Özellikleri", "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem", 'İslam Dinine Göre Kötü Davranışlar', 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)', 'Hac ibadeti'],
  image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/a58167ac-e09a-4736-bf01-faa35ee6e6a7/image_fx__(10).jpg'
}];
export function Questions() {
  const [selectedSubject, setSelectedSubject] = useState<(typeof subjects)[0] | null>(null);
  const [selectedTopic, setSelectedTopic] = useState<string | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<SubTopic | null>(null);
  const [showNewQuestion, setShowNewQuestion] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState<Question | null>(null);
  const [questions, setQuestions] = useState<Question[]>(() => {
    const saved = localStorage.getItem('questions');
    const parsed = saved ? JSON.parse(saved) : [];
    // Add views property if it doesn't exist
    return parsed.map((q: any) => ({
      ...q,
      views: q.views || Math.floor(Math.random() * 50) + 1
    }));
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [visibilityFilter, setVisibilityFilter] = useState('everyone');
  const [sortOption, setSortOption] = useState('newest');
  const [showShareModal, setShowShareModal] = useState(false);
  const [questionToShare, setQuestionToShare] = useState<Question | null>(null);
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [showVisibilityDropdown, setShowVisibilityDropdown] = useState(false);
  const [activeStep, setActiveStep] = useState<'subject' | 'topic' | 'testList' | 'testStart' | 'solve' | 'results'>('subject');
  const [questionsForSolving, setQuestionsForSolving] = useState<any[]>([]);
  const [testResults, setTestResults] = useState<any>(null);
  const [reviewQuestionId, setReviewQuestionId] = useState<number | null>(null);
  const [availableTests, setAvailableTests] = useState<Test[]>([]);
  const [selectedTest, setSelectedTest] = useState<Test | null>(null);
  const [showConfirmFinish, setShowConfirmFinish] = useState(false);
  const handleLike = (questionId: number) => {
    const currentUserId = 'currentUser';
    setQuestions(prev => {
      const updated = prev.map(q => {
        if (q.id === questionId) {
          const likes = q.likes.includes(currentUserId) ? q.likes.filter(id => id !== currentUserId) : [...q.likes, currentUserId];
          return {
            ...q,
            likes
          };
        }
        return q;
      });
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
  };
  const handleArchive = (questionId: number) => {
    setQuestions(prev => {
      const updated = prev.map(q => q.id === questionId ? {
        ...q,
        archived: !q.archived
      } : q);
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
  };
  const handleView = (questionId: number) => {
    setQuestions(prev => {
      const updated = prev.map(q => q.id === questionId ? {
        ...q,
        views: q.views + 1
      } : q);
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
  };
  const handleShare = (questionId: number) => {
    const question = questions.find(q => q.id === questionId);
    if (question) {
      setQuestionToShare(question);
      setShowShareModal(true);
    }
  };
  const handleShareSubmit = (data: {
    recipientId: string;
    note: string;
  }) => {
    // In a real app, this would send the share data to the server
    console.log(`Shared question ${questionToShare?.id} with ${data.recipientId}. Note: ${data.note}`);
    setShowShareModal(false);
    setQuestionToShare(null);
  };
  const handleAddResponse = (questionId: number, response: {
    content: string;
    image?: File;
  }) => {
    setQuestions(prev => {
      const updated = prev.map(q => {
        if (q.id === questionId) {
          const newResponse = {
            id: Date.now(),
            author: 'Ben',
            authorType: 'student' as const,
            content: response.content,
            image: response.image ? URL.createObjectURL(response.image) : undefined,
            createdAt: new Date().toISOString()
          };
          return {
            ...q,
            responses: [...q.responses, newResponse]
          };
        }
        return q;
      });
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
  };
  const handleVerifyResponse = (questionId: number, responseId: number) => {
    setQuestions(prev => {
      const updated = prev.map(q => {
        if (q.id === questionId) {
          const responses = q.responses.map(r => r.id === responseId ? {
            ...r,
            verified: !r.verified
          } : r);
          return {
            ...q,
            responses
          };
        }
        return q;
      });
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
  };
  const handlePinResponse = (questionId: number, responseId: number) => {
    setQuestions(prev => {
      const updated = prev.map(q => {
        if (q.id === questionId) {
          const responses = q.responses.map(r => r.id === responseId ? {
            ...r,
            pinned: !r.pinned
          } : r);
          return {
            ...q,
            responses
          };
        }
        return q;
      });
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
  };
  const handleSubmit = (data: {
    title: string;
    content: string;
    options: string[];
    correctOption: number;
    image?: File;
    visibility: 'everyone' | 'institution' | 'private';
    targetUsers?: string[];
  }) => {
    const newQuestion: Question = {
      id: questions.length + 1,
      title: data.title,
      content: data.content,
      subject: selectedSubject?.title || '',
      topic: selectedTopic || '',
      author: 'Ben',
      authorType: 'student',
      createdAt: new Date().toISOString(),
      options: data.options,
      correctOption: data.correctOption,
      image: data.image ? URL.createObjectURL(data.image) : undefined,
      likes: [],
      views: 0,
      visibility: data.visibility,
      targetUsers: data.targetUsers,
      archived: false,
      responses: []
    };
    setQuestions(prev => {
      const updated = [...prev, newQuestion];
      localStorage.setItem('questions', JSON.stringify(updated));
      return updated;
    });
    setShowNewQuestion(false);
  };
  const handleBackFromUnit = () => {
    setSelectedUnit(null);
    setSelectedTopic(null);
  };
  // Sort questions based on selected option
  const sortQuestions = (questions: Question[]) => {
    switch (sortOption) {
      case 'newest':
        return [...questions].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      case 'oldest':
        return [...questions].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
      case 'mostLiked':
        return [...questions].sort((a, b) => b.likes.length - a.likes.length);
      case 'mostViewed':
        return [...questions].sort((a, b) => b.views - a.views);
      default:
        return questions;
    }
  };
  // Generate tests for a topic
  const generateTestsForTopic = (topic: string) => {
    // Generate 3 tests with different difficulties
    const tests: Test[] = [{
      id: 1,
      title: `${topic} - Test 1`,
      questionCount: 10,
      difficulty: 'Kolay',
      timeLimit: 15,
      description: `${topic} konusunda temel kavramları pekiştirmek için hazırlanmış kolay seviye test.`,
      questions: generateQuestionsForTest(topic, 10, 'Kolay')
    }, {
      id: 2,
      title: `${topic} - Test 2`,
      questionCount: 15,
      difficulty: 'Orta',
      timeLimit: 25,
      description: `${topic} konusunda orta seviye bilgi gerektiren, kavramları derinleştiren test.`,
      questions: generateQuestionsForTest(topic, 15, 'Orta')
    }, {
      id: 3,
      title: `${topic} - Test 3`,
      questionCount: 20,
      difficulty: 'Zor',
      timeLimit: 35,
      description: `${topic} konusunda ileri seviye, LGS'ye hazırlık için kritik öneme sahip test.`,
      questions: generateQuestionsForTest(topic, 20, 'Zor')
    }];
    return tests;
  };
  // Generate questions for a test
  const generateQuestionsForTest = (topic: string, count: number, difficulty: 'Kolay' | 'Orta' | 'Zor') => {
    return Array.from({
      length: count
    }, (_, i) => ({
      id: i + 1,
      content: `${topic} konusu ile ilgili ${difficulty.toLowerCase()} seviye soru ${i + 1}. Bu soruda sizden istenen...`,
      image: i % 3 === 0 ? `https://picsum.photos/seed/${i + 100}/800/400` : undefined,
      options: [{
        id: `q${i + 1}_a`,
        text: `${topic} için cevap seçeneği A`
      }, {
        id: `q${i + 1}_b`,
        text: `${topic} için cevap seçeneği B`
      }, {
        id: `q${i + 1}_c`,
        text: `${topic} için cevap seçeneği C`
      }, {
        id: `q${i + 1}_d`,
        text: `${topic} için cevap seçeneği D`
      }],
      correctOptionId: `q${i + 1}_${['a', 'b', 'c', 'd'][Math.floor(Math.random() * 4)]}`,
      explanation: `Bu sorunun çözümü için ${topic} konusundaki temel prensipleri uygulamanız gerekiyor...`,
      videoUrl: i % 5 === 0 ? 'https://www.youtube.com/embed/dQw4w9WgXcQ' : undefined
    }));
  };
  // Function to start solving a specific test
  const handleSelectTest = (test: Test) => {
    setSelectedTest(test);
    setActiveStep('testStart');
  };
  // Function to actually start the test (transition from testStart to solve)
  const handleStartTest = () => {
    if (selectedTest) {
      setQuestionsForSolving(selectedTest.questions);
      setActiveStep('solve');
    }
  };
  // Function to retake a test
  const handleRetakeTest = () => {
    if (selectedTest) {
      setQuestionsForSolving(selectedTest.questions);
      setTestResults(null);
      setActiveStep('solve');
    }
  };
  // Function to go back to home/subject selection
  const handleGoHome = () => {
    setSelectedSubject(null);
    setSelectedTopic(null);
    setSelectedUnit(null);
    setSelectedTest(null);
    setTestResults(null);
    setActiveStep('subject');
  };
  // Function to review a specific question
  const handleReviewQuestion = (questionId: number) => {
    setReviewQuestionId(questionId);
    setQuestionsForSolving(selectedTest?.questions || []);
    setActiveStep('solve');
  };
  // Check if a test has been completed previously
  const isTestCompleted = (testId: number) => {
    // Check localStorage for completed tests
    const completedTests = localStorage.getItem('completedTests');
    if (completedTests) {
      const completed = JSON.parse(completedTests);
      return completed.includes(`${selectedSubject?.id}_${selectedTopic}_${testId}`);
    }
    return false;
  };
  // When a topic is selected, generate tests for it
  useEffect(() => {
    if (selectedTopic && activeStep === 'testList') {
      const tests = generateTestsForTopic(selectedTopic);
      setAvailableTests(tests);
    }
  }, [selectedTopic, activeStep]);
  // Handle finishing the test
  const handleFinishTest = (results: any) => {
    // Save the test as completed in localStorage
    if (selectedTest && selectedSubject && selectedTopic) {
      const testId = `${selectedSubject.id}_${selectedTopic}_${selectedTest.id}`;
      const completedTests = localStorage.getItem('completedTests');
      const completed = completedTests ? JSON.parse(completedTests) : [];
      if (!completed.includes(testId)) {
        completed.push(testId);
        localStorage.setItem('completedTests', JSON.stringify(completed));
      }
    }
    setTestResults(results);
    setActiveStep('results');
  };
  // Render based on the active step
  if (activeStep === 'results') {
    return <TestResultsScreen subjectId={selectedSubject?.id || ''} subjectTitle={selectedSubject?.title || ''} topic={selectedTopic || ''} results={testResults} onRetakeTest={handleRetakeTest} onGoHome={handleGoHome} onReviewQuestion={handleReviewQuestion} data-id="element-2958" />;
  }
  if (activeStep === 'solve') {
    // If reviewing a specific question, set the starting index to that question
    let startingQuestionIndex = 0;
    let reviewMode = false;
    if (reviewQuestionId) {
      const index = questionsForSolving.findIndex(q => q.id === reviewQuestionId);
      if (index !== -1) {
        startingQuestionIndex = index;
        reviewMode = true;
      }
      // Reset review question id after finding it
      setReviewQuestionId(null);
    }
    return <QuestionSolveInterface subjectId={selectedSubject?.id || ''} subjectTitle={selectedSubject?.title || ''} topic={selectedTopic || ''} questions={questionsForSolving} onFinish={handleFinishTest} onBack={() => setActiveStep(reviewMode ? 'results' : 'testList')} startingQuestionIndex={startingQuestionIndex} reviewMode={reviewMode} initialSelectedOptions={testResults?.selectedOptions || {}} initialShowSolution={questionsForSolving.reduce((acc, q) => ({
      ...acc,
      [q.id]: reviewMode
    }), {})} initialArchivedQuestions={testResults?.archivedQuestions || []} timeLimit={selectedTest?.timeLimit || 0} testTitle={selectedTest?.title || ''} onConfirmFinish={() => setShowConfirmFinish(true)} data-id="element-2959" />;
  }
  if (activeStep === 'testStart' && selectedTest) {
    const gradient = getSubjectGradient(selectedSubject?.id || '');
    return <div className="flex flex-col items-center justify-center min-h-[70vh] space-y-8" data-id="element-2960">
        <div className="text-center space-y-2" data-id="element-2961">
          <h1 className="text-3xl md:text-4xl font-bold" data-id="element-2962">
            {selectedTest.title}
          </h1>
          <p className="text-xl text-gray-300" data-id="element-2963">
            {selectedSubject?.title} - {selectedTopic}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-3xl" data-id="element-2964">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-500 to-cyan-500" data-id="element-2965">
            <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-2966">
              <div className="flex flex-col items-center justify-center space-y-2 h-full" data-id="element-2967">
                <BookOpen className="w-8 h-8 text-blue-400" data-id="element-2968" />
                <h3 className="text-lg font-medium" data-id="element-2969">Soru Sayısı</h3>
                <p className="text-3xl font-bold text-blue-400" data-id="element-2970">
                  {selectedTest.questionCount}
                </p>
              </div>
            </div>
          </div>
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-amber-500 to-orange-500" data-id="element-2971">
            <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-2972">
              <div className="flex flex-col items-center justify-center space-y-2 h-full" data-id="element-2973">
                <Clock className="w-8 h-8 text-amber-400" data-id="element-2974" />
                <h3 className="text-lg font-medium" data-id="element-2975">Süre</h3>
                <p className="text-3xl font-bold text-amber-400" data-id="element-2976">
                  {selectedTest.timeLimit} dk
                </p>
              </div>
            </div>
          </div>
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-500 to-green-500" data-id="element-2977">
            <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-2978">
              <div className="flex flex-col items-center justify-center space-y-2 h-full" data-id="element-2979">
                <BarChart2 className="w-8 h-8 text-emerald-400" data-id="element-2980" />
                <h3 className="text-lg font-medium" data-id="element-2981">Zorluk</h3>
                <p className="text-3xl font-bold text-emerald-400" data-id="element-2982">
                  {selectedTest.difficulty}
                </p>
              </div>
            </div>
          </div>
        </div>
        {selectedTest.description && <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-3xl" data-id="element-2983">
            <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-2984">
              <h3 className="text-lg font-medium mb-2" data-id="element-2985">Test Hakkında</h3>
              <p className="text-gray-300" data-id="element-2986">{selectedTest.description}</p>
            </div>
          </div>}
        <div className="flex flex-col sm:flex-row gap-4 mt-6" data-id="element-2987">
          <button onClick={() => setActiveStep('testList')} className="flex items-center justify-center gap-2 px-8 py-3 bg-white/10 rounded-lg text-white hover:bg-white/20 transition-colors" data-id="element-2988">
            <ArrowLeft className="w-5 h-5" data-id="element-2989" />
            Geri Dön
          </button>
          <button onClick={handleStartTest} className={`flex items-center justify-center gap-2 px-8 py-3 bg-gradient-to-r ${gradient.from} ${gradient.to} rounded-lg text-white hover:opacity-90 transition-colors`} data-id="element-2990">
            Testi Başlat
            <ArrowRight className="w-5 h-5" data-id="element-2991" />
          </button>
        </div>
      </div>;
  }
  if (activeStep === 'testList' && selectedTopic) {
    const gradient = getSubjectGradient(selectedSubject?.id || '');
    return <div className="space-y-6" data-id="element-2992">
        <div className="flex items-center gap-4" data-id="element-2993">
          <button onClick={() => {
          if (selectedSubject?.id === 'fen' && selectedUnit) {
            handleBackFromUnit();
          } else {
            setSelectedTopic(null);
            setActiveStep('subject');
          }
          setActiveStep('topic');
        }} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-2994">
            <ArrowLeft className="w-5 h-5" data-id="element-2995" />
            Geri
          </button>
          <div data-id="element-2996">
            <h1 className="text-2xl font-bold" data-id="element-2997">
              {selectedSubject?.title} - {selectedTopic}
            </h1>
            <p className="text-gray-400 mt-1" data-id="element-2998">
              Toplam {availableTests.length} test
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2999">
          {availableTests.map(test => {
          const completed = isTestCompleted(test.id);
          return <div key={test.id} onClick={() => handleSelectTest(test)} className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 cursor-pointer hover:shadow-[0_0_15px_rgba(168,85,247,0.4)] transition-all duration-300" data-id="element-3000">
                <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-3001">
                  <div className="flex flex-col h-full" data-id="element-3002">
                    {completed && <div className="absolute top-3 right-3 bg-green-500/20 text-green-400 px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1" data-id="element-3003">
                        <CheckCircle className="w-3 h-3" data-id="element-3004" />
                        Çözüldü
                      </div>}
                    <h3 className="text-xl font-bold mb-3" data-id="element-3005">{test.title}</h3>
                    <div className="flex flex-wrap gap-3 mb-4" data-id="element-3006">
                      <span className="inline-flex items-center gap-1 px-3 py-1 bg-blue-500/20 text-blue-400 rounded-full text-sm" data-id="element-3007">
                        <BookOpen className="w-4 h-4" data-id="element-3008" />
                        {test.questionCount} Soru
                      </span>
                      <span className="inline-flex items-center gap-1 px-3 py-1 bg-amber-500/20 text-amber-400 rounded-full text-sm" data-id="element-3009">
                        <Clock className="w-4 h-4" data-id="element-3010" />
                        {test.timeLimit} dk
                      </span>
                      <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm ${test.difficulty === 'Kolay' ? 'bg-green-500/20 text-green-400' : test.difficulty === 'Orta' ? 'bg-yellow-500/20 text-yellow-400' : 'bg-red-500/20 text-red-400'}`} data-id="element-3011">
                        <Award className="w-4 h-4" data-id="element-3012" />
                        {test.difficulty}
                      </span>
                    </div>
                    {test.description && <p className="text-gray-400 text-sm mb-4 line-clamp-2" data-id="element-3013">
                        {test.description}
                      </p>}
                    <div className="mt-auto" data-id="element-3014">
                      <button className={`w-full py-2 px-4 bg-gradient-to-r ${gradient.from} ${gradient.to} rounded-lg text-white font-medium hover:opacity-90 transition-colors flex items-center justify-center gap-2`} data-id="element-3015">
                        <Play className="w-4 h-4" data-id="element-3016" />
                        {completed ? 'Tekrar Çöz' : 'Teste Başla'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>;
  }
  if (!selectedSubject) {
    return <div className="space-y-6" data-id="element-3017">
        <h1 className="text-2xl font-bold" data-id="element-3018">Soru Çözüm</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3019">
          {subjects.map(subject => {
          const gradient = getSubjectGradient(subject.id);
          return <div key={subject.id} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradient.from} ${gradient.to} group cursor-pointer`} onClick={() => {
            setSelectedSubject(subject);
            setActiveStep('topic');
          }} data-id="element-3020">
                <div className="relative bg-black/90 rounded-lg h-full" data-id="element-3021">
                  <div className="relative aspect-[16/9]" data-id="element-3022">
                    <img src={subject.image} alt={subject.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-3023" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent" data-id="element-3024" />
                    <div className="absolute inset-0 flex items-end justify-center p-8" data-id="element-3025">
                      <h3 className="text-xl font-semibold text-center" data-id="element-3026">
                        {subject.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>;
  }
  if (!selectedTopic && selectedSubject.id === 'fen') {
    // Fen Bilimleri için özel görünüm - Üniteleri göster
    const gradient = getSubjectGradient(selectedSubject.id);
    return <div className="space-y-6" data-id="element-3027">
        <div className="flex items-center gap-4" data-id="element-3028">
          <button onClick={() => setSelectedSubject(null)} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-3029">
            <ArrowLeft className="w-5 h-5" data-id="element-3030" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-3031">{selectedSubject.title}</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3032">
          {selectedSubject.subTopics && selectedSubject.subTopics.map((unit, index) => <div key={index} onClick={() => {
          setSelectedUnit(unit);
          setSelectedTopic(unit.title);
        }} className="relative p-[1px] rounded-lg overflow-hidden border border-emerald-500 cursor-pointer hover:shadow-[0_0_10px_rgba(16,185,129,0.4)] transition-all duration-300" data-id="element-3033">
                <div className="relative p-6 bg-black/95 rounded-lg" data-id="element-3034">
                  <h3 className="text-lg font-medium text-center" data-id="element-3035">
                    {unit.title}
                  </h3>
                </div>
              </div>)}
        </div>
      </div>;
  }
  if (selectedUnit && selectedSubject.id === 'fen') {
    // Fen Bilimleri için alt konular
    const gradient = getSubjectGradient(selectedSubject.id);
    return <div className="space-y-6" data-id="element-3036">
        <div className="flex items-center gap-4" data-id="element-3037">
          <button onClick={handleBackFromUnit} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-3038">
            <ArrowLeft className="w-5 h-5" data-id="element-3039" />
            Geri
          </button>
          <div data-id="element-3040">
            <h1 className="text-2xl font-bold" data-id="element-3041">
              {selectedSubject.title} - {selectedUnit.title}
            </h1>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3042">
          {selectedUnit.topics.map((topic, index) => <div key={index} onClick={() => {
          setSelectedTopic(topic);
          setActiveStep('testList');
        }} className="relative p-[1px] rounded-lg overflow-hidden border border-emerald-500 cursor-pointer hover:shadow-[0_0_10px_rgba(16,185,129,0.4)] transition-all duration-300" data-id="element-3043">
              <div className="relative p-6 bg-black/95 rounded-lg" data-id="element-3044">
                <h3 className="text-lg font-medium text-center" data-id="element-3045">{topic}</h3>
              </div>
            </div>)}
        </div>
      </div>;
  }
  if (!selectedTopic && selectedSubject.id !== 'fen') {
    // Get border color based on subject
    let borderColor = 'border-purple-500'; // Default
    const gradient = getSubjectGradient(selectedSubject.id);
    switch (selectedSubject.id) {
      case 'turkce':
        borderColor = 'border-red-500';
        break;
      case 'matematik':
        borderColor = 'border-blue-500';
        break;
      case 'fen':
        borderColor = 'border-emerald-500';
        break;
      case 'inkılap':
        borderColor = 'border-amber-700';
        break;
      case 'din':
        borderColor = 'border-blue-900';
        break;
      case 'ingilizce':
        borderColor = 'border-purple-500';
        break;
    }
    return <div className="space-y-6" data-id="element-3046">
        <div className="flex items-center gap-4" data-id="element-3047">
          <button onClick={() => {
          setSelectedSubject(null);
          setActiveStep('subject');
        }} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-3048">
            <ArrowLeft className="w-5 h-5" data-id="element-3049" />
            Geri
          </button>
          <h1 className="text-2xl font-bold" data-id="element-3050">{selectedSubject.title}</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3051">
          {selectedSubject.topics.map(topic => <div key={topic} onClick={() => {
          setSelectedTopic(topic);
          setActiveStep('testList');
        }} className={`relative p-[1px] rounded-lg overflow-hidden border ${borderColor} cursor-pointer hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300`} data-id="element-3052">
              <div className="relative p-6 bg-black/95 rounded-lg" data-id="element-3053">
                <h3 className="text-lg font-medium text-center" data-id="element-3054">{topic}</h3>
              </div>
            </div>)}
        </div>
      </div>;
  }
  // This should not be reached with the new flow
  const gradient = getSubjectGradient(selectedSubject.id);
  return <div className="space-y-6" data-id="element-3055">
      <div className="flex items-center gap-4" data-id="element-3056">
        <button onClick={() => {
        setSelectedTopic(null);
        setActiveStep('topic');
      }} className={`flex items-center gap-2 px-4 py-2 rounded-lg border bg-gradient-to-r ${gradient.from} ${gradient.to} text-white hover:opacity-90 transition-all`} data-id="element-3057">
          <ArrowLeft className="w-5 h-5" data-id="element-3058" />
          Geri
        </button>
        <h1 className="text-2xl font-bold" data-id="element-3059">
          {selectedSubject.title} - {selectedTopic}
        </h1>
      </div>
      <div className="text-center py-8" data-id="element-3060">
        <p className="text-gray-400" data-id="element-3061">
          Lütfen testler listesine dönmek için geri butonuna tıklayın.
        </p>
      </div>
    </div>;
}